import { useTranslation } from 'react-i18next'

import type { TracingUrlInsight } from '@shared/api/rtkQuery'
import useTracingUrlStatus from '@shared/lib/hooks/useTracingUrlStatus'

type Props = {
  tracingUrlInsights?: Array<TracingUrlInsight>
}

const useGetErrorHint = ({ tracingUrlInsights }: Props) => {
  const { t } = useTranslation(['workflow'])
  const { checkTracingUrlIsArchived } = useTracingUrlStatus()

  if (!tracingUrlInsights?.length) {
    return ''
  }

  const hasError = tracingUrlInsights
    // action_url 來源的列（MAAC line_push）不是受管理的 tracing_url，沒有對應記錄，
    // 不做「失效」比對；只檢查真正受管理的 tracing_url。
    .filter(item => !item.isActionUrl)
    .map(item => checkTracingUrlIsArchived(item.id, item.archivedAt))
    .some(Boolean)

  return hasError
    ? t('workflow:errors.tracing_url_is_archived_plz_recreate')
    : ''
}

export default useGetErrorHint
